export default __webpack_public_path__ + "static/migliori-strumenti-per-business-intelligence-72288d748c30402dde0a4310e627b070.jpg";